import { disclaimerText } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function About() {
  return (
    <section id="about" className="scroll-mt-16 bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto grid max-w-content gap-10 px-4 md:px-6 lg:grid-cols-2">
        <div>
          <SectionHeading
            eyebrow="关于吃瓜图集"
            title="把散落的瓜，整理成看得懂的档案"
            desc="吃瓜图集诞生于一个朴素的念头：网上围绕同一事件的截图零散又难找，谁都想少翻一点聊天记录、快一点看清来龙去脉。于是我们把这些内容按事件统一归档。"
          />
          <div className="flex flex-col gap-3">
            <div className="flex items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className="ri-filter-3-line text-lg" />
              </span>
              <div>
                <h4 className="text-sm font-semibold text-foreground-950">只做整理，不做断言</h4>
                <p className="mt-1 text-sm leading-relaxed text-foreground-500">
                  我们把多方说法、公开回应与评论区观点并列呈现，由你自己判断，而不是替你下结论。
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                <i className="ri-shield-user-line text-lg" />
              </span>
              <div>
                <h4 className="text-sm font-semibold text-foreground-950">隐私边界先行</h4>
                <p className="mt-1 text-sm leading-relaxed text-foreground-500">
                  涉及真实个人核心隐私与联系方式的内容不予收录，头像与账号信息一律打码处理。
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-2xl border border-background-200 bg-background-50 p-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-secondary-800">
                <i className="ri-focus-3-line text-lg" />
              </span>
              <div>
                <h4 className="text-sm font-semibold text-foreground-950">时间线即检索入口</h4>
                <p className="mt-1 text-sm leading-relaxed text-foreground-500">
                  每一套图集都按「首曝 → 回应 → 补充 → 复盘」的顺序排布，新内容进来自动续在时间线末尾。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8">
          <div className="flex items-center gap-2 text-foreground-950">
            <i className="ri-scales-3-line text-xl text-primary-500" />
            <h3 className="font-heading text-xl font-bold">内容与版权说明</h3>
          </div>
          <p className="mt-2 text-sm leading-relaxed text-foreground-500">
            站内展示的事件均为泛指性演示内容，不代表对任何真实个人或组织的判断。我们严格遵守以下收录原则：
          </p>
          <ul className="mt-5 flex flex-col gap-3">
            {disclaimerText.map((d, i) => (
              <li key={i} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-600">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
                {d}
              </li>
            ))}
          </ul>
          <div className="mt-6 flex flex-col gap-3 border-t border-dashed border-background-300 pt-5 sm:flex-row sm:items-center sm:justify-between">
            <p className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-send-line text-primary-500" />
              权益与投稿联系
            </p>
            <a
              href="mailto:hello@chiguatuji.com"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-foreground-800"
            >
              hello@chiguatuji.com
              <i className="ri-arrow-right-up-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}